<template>
	<div>

		<!-- 店铺详情 -->
		<cube-page :title="isAdd ? '导游申请' : '导游编辑'">
			<div slot="content">
				<div class="shopxq leopages">
					<van-form @submit="onSubmit">
						<van-field v-model="entry.nickname" clearable label="名称" placeholder="请输入名称" name="nickname" required
							:rules="[{ required: true, message: '请填写名称' }]" />
						<van-field v-model="entry.age" clearable label="年龄" placeholder="请输入年龄" name="age" required
							:rules="[{ required: true, message: '请填写年龄' }]" />
						<van-field name="radio" label="性別" :rules="[{ required: true, message: '请选择性别' }]" required>
							<template #input>
								<van-radio-group v-model="entry.gender" direction="horizontal">
									<van-radio name="10">男</van-radio>
									<van-radio name="20">女</van-radio>
									<van-radio name="30">其它</van-radio>
								</van-radio-group>
							</template>
						</van-field>
						<van-field required name="checkboxGroup" label="语种" :rules="[{ required: true, message: '请选择语种' }]">
							<template #input>
								<van-checkbox-group v-model="textList.lang" direction="horizontal">
									<van-checkbox v-for="item in pickerList['lang']" :key="item.value" :name="item.value"
										shape="square">{{ item.text }}</van-checkbox>
								</van-checkbox-group>
							</template>
						</van-field>
						<van-field v-model="entry.phone" clearable label="联系电话" placeholder="联系电话" name="phone" required
							:rules="[{ required: true, message: '请填写联系电话' }]" type="number" />
						<van-field name="avatar" label="头像" required :rules="[{ required: true, message: '请上传头像' }]">
							<template #input>
								<van-uploader :after-read="afterRead" v-model="avatar" :max-count="1" />
							</template>
						</van-field>
						<van-field name="license" label="导游证" required :rules="[{ required: true, message: '请上传导游证' }]">
							<template #input>
								<van-uploader :after-read="afterReadId" v-model="guideLicense" :max-count="1" />
							</template>
						</van-field>
						<van-field required readonly clickable name="picker" :value="textList.rank" label="职级" placeholder="点击选择职级"
							@click="showPickerFun('rank')" :rules="[{ required: true, message: '请选择职级' }]" />
						<van-field required name="checkboxGroup" label="擅长" :rules="[{ required: true, message: '请选择擅长' }]">
							<template #input>
								<van-checkbox-group v-model="textList.skill" direction="horizontal">
									<van-checkbox v-for="item in pickerList['skill']" :key="item.value" :name="item.value"
										shape="square">{{ item.text }}</van-checkbox>
								</van-checkbox-group>
							</template>
						</van-field>
						<van-field v-model="entry.intro" show-word-limit rows="2" autosize maxlength="500" type="textarea" clearable
							label="自我介绍" placeholder="请输入自我介绍/至少30字" name="intro" required
							:rules="[{ required: true, message: '请填写自我介绍' }]" />
						<van-field v-model="entry.slogan" show-word-limit rows="2" autosize maxlength="500" type="textarea"
							clearable label="标语" placeholder="请输入标语 如：华夏五千年,金牌讲解" name="slogan" />
						<van-field v-model="entry.tags" show-word-limit rows="2" autosize maxlength="500" type="textarea" clearable
							label="标签" placeholder="请输入标签 如：搞笑,专业" name="tags" />
						<div style="margin: 16px;">
							<van-button round block type="info" :loading="loading" native-type="submit">提交</van-button>
						</div>
						<van-field name="checkbox" class="tk">
							<template #input>
								<van-checkbox v-model="checked">我已阅读，并同意<a class="agree"
										@click="goXieyi">《免责申明》和《用户注册服务协议》</a></van-checkbox>
							</template>
						</van-field>
					</van-form>
				</div>
			</div>
		</cube-page>
		<van-popup v-model="showPicker" position="bottom">
			<van-picker :title="pickerTitleActive" show-toolbar :default-index="textList.rank_index" :columns="columns"
				@confirm="onConfirm" @cancel="showPicker = false" />
		</van-popup>
	</div>
</template>

<script>
import {
	Toast,
} from 'vant';
import CubePage from '../../TP/cube-page.vue'
import * as util from '@/utils/network'
import * as imgcl from '@/utils/img'
import Exif from "exif-js";
import {
	redirect
} from "@/utils/network";
export default {
	components: {
		CubePage,
	},
	data() {
		return {
			isAdd: true,
			entry: {
				nickname: '', //	公司名称
				age: '', //年龄
				gender: '', // 性别
				image: '', // 导游证
				lang: [], // 语种
				phone: '', // 手机
				avatar_url: '', // 头像
				slogan: '', //	标语
				rank: '', // 职级
				intro: '', //	简介
				tags: '', // 标签
				skill: [], // 擅长
			},
			avatarobj: '', //头像上传
			idcardobj: '', //证件上传
			avatar: [],
			checked: false,
			guideLicense: [],
			strCropper: null,
			pickerList: {
				rank: [],
				lang: [],
				skill: []
			},
			showPicker: false,
			objkey: '',
			columns: [],
			textList: {
				rank: '',
				rank_index: 0,
				lang: [],
				skill: [],
			},
			pickerTitle: {
				rank: '职级',
				lang: '语言',
				skill: '擅长'
			},
			pickerTitleActive: '',
			loading: false
		}
	},
	methods: {
		//跳转协议页
		goXieyi() {
			redirect('xieyi?place=110');
		},
		// 导游证件
		afterReadId(file) {
			this.idcardobj = ''
			this.strCropper = 'idcard'
			this.imgPreview(file.file, 300);
		},
		// 头像
		afterRead(file) {
			this.avatarobj = ''
			this.strCropper = 'avatar'
			this.imgPreview(file.file, 300);
		},
		imgPreview(file, sizekb) {
			let self = this;
			let Orientation;
			//去获取拍照时的信息，解决拍出来的照片旋转问题   npm install exif-js --save   这里需要安装一下包
			Exif.getData(file, function () {
				Orientation = Exif.getTag(this, "Orientation");
			});
			// 看支持不支持FileReader
			if (!file || !window.FileReader) return '不支持FileReader';
			if (/^image/.test(file.type)) {
				// 创建一个reader
				let reader = new FileReader();
				// 将图片2将转成 base64 格式
				reader.readAsDataURL(file);
				// 读取成功后的回调
				reader.onloadend = function () {
					let result = this.result;
					let img = new Image();
					img.src = result;
					//判断图片是否大于500K,是就直接上传，反之压缩图片
					if (this.result.length <= sizekb * 1024) {
						// 上传图片
						if (self.strCropper == 'avatar') {
							self.avatarobj = this.result;
						} else if (self.strCropper == 'idcard') {
							self.idcardobj = this.result;
						}
					} else {
						img.onload = function () {
							let data = imgcl.compress(img, Orientation);
							if (self.strCropper == 'avatar') {
								self.avatarobj = data
							} else if (self.strCropper == 'idcard') {
								self.idcardobj = data;
							}
						};
					}
				};
			}
		},
		onSubmit() {
			if (!this.checked) {
				Toast('请勾选并阅读条款')
				return
			}
			this.loading = true;
			let { skill, lang } = this.textList; // 技能和语言
			this.entry.skill = skill.join(',');
			this.entry.lang = lang.join(',');
			if (this.avatarobj) {
				this.entry.avatar = this.avatarobj
			}
			if (this.idcardobj) {
				this.entry.image = this.idcardobj
			}
			this.entry.pact = this.checked ? 1 : 0;
			console.log(this.entry)
			let url = "/addons/litestore/api.guide/save"
			util.post(url, this.entry, (result) => {
				this.loading = false;
				Toast(result.msg);
				if (result.code == 1) {
					util.redirect('guideHome');
				}
			});
			setTimeout(() => {
				this.loading = false;
			}, 2000)
		},
		// 初始化获取导游信息
		getData() {
			var url = "/addons/litestore/api.guide/save"
			util.get(url, {}, (result) => {
				if (result.data != null) {
					this.isAdd = false;
					let data = JSON.parse(JSON.stringify(result.data));
					let { guide, lang_list, rank_list, skill_list } = data;
					this.pickerList['rank'] = rank_list;
					this.pickerList['lang'] = lang_list;
					this.pickerList['skill'] = skill_list;
					if (!guide) return;
					let { nickname, age, gender, image_url, lang, phone, avatar_url, image, avatar, slogan, rank, intro, tags, skill, pact, rank_text } = guide;
					lang = lang ? lang.split(',').map(Number) : '';
					skill = skill ? skill.split(',').map(Number) : '';
					let rank_index = 0;
					let textListNew = {
						rank: rank_text, // 职级要求
						rank_index,//语种要求
						lang,//语种要求
						skill,//技能要求
					};
					this.pickerList['rank'].forEach((item, index) => {
						if (item.value == Number(rank)) {
							rank_text = item.text;
							rank_index = index;
						}
					});
					this.textList = textListNew;
					let obj = {
						nickname, //	公司名称
						age, //年龄
						gender, // 性别
						image_url, // 导游证
						lang, // 语种
						phone, // 手机
						avatar_url, // 头像
						slogan, //	标语
						rank: Number(rank), // 职级
						intro, //	简介
						tags, // 标签
						skill, // 擅长
						image,
						avatar,
					};
					this.avatar = avatar_url ? [{ url: avatar_url }] : []; //头像
					this.guideLicense = avatar_url ? [{ url: image_url }] : []; //导游证
					this.entry = obj
					this.checked = pact;
				}
			});
		},
		// 下拉其它选项
		showPickerFun(type) {
			this.showPicker = true;
			this.objkey = type;
			this.columns = this.pickerList[type];
			this.pickerTitleActive = this.pickerTitle[type];
		},
		// 确认选中其它选项
		onConfirm(val) {
			this.entry[this.objkey] = val.value;
			this.textList[this.objkey] = val.text;
			this.showPicker = false;
		},
	},
	created() {
		this.getData()
	}
}
</script>
<style type="text/css" lang="less">
.van-form {
	background-color: #FFFFFF;
	padding: 20px 0;

	.tk {
		font-size: 12px;
		text-align: center;

		a {
			color: #000;
		}

		.van-field__control:read-only {
			justify-content: center !important;
		}
	}
}

.van-nav-bar {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
}

.van-hairline--bottom::after {
	border-bottom-width: 0px;
}

.height100 {
	height: 100vh;
}

.flex-column-center {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
}

.vue-cropper {
	background: #000 !important;

	.cropper-view-box {
		outline: 1px solid #fff !important;
		outline-color: #fff !important;
	}
}

.footerB {
	background: #000 !important;
	padding: 10px 15px;
	width: 100%;
	box-sizing: border-box;
	display: flex;
	justify-content: space-between;
	align-items: center;

	.fitem {
		color: #FFFFFF;
		// width:50px;
	}
}

.vanfield {
	.van-field__value {
		flex: none;
	}

	.van-icon-success {
		border-radius: 4px;
	}
}

.van-checkbox {
	margin-bottom: 10px;
}
</style>
